import Button from "@mui/material/Button";
import { Link } from "react-router";
import { MinimalCase } from "@/src/types/Entities/MinimalCase";
import { messageCaseStyle } from "./messageCaseStyle";

export default function MessageCaseOpenButton({ minimalCase }: { minimalCase: MinimalCase }) {
  return (
    <Button
      component={Link}
      to={`/servicewelt/nachrichten/fall/${minimalCase.id}`}
      aria-label={`Nachrichten zu Fall ${minimalCase.reference} öffnen`}
      variant={"outlined"}
      size={"small"}
      sx={messageCaseStyle.openButton}
    >
      Nachrichten öffnen
    </Button>
  );
}
